import React, { useState, useMemo } from "react";

const genderOptions = [
  { value: "", label: "Select gender" },
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];

function UserModal({ isOpen, onClose, onCreate, clients = [] }) {
  const [saving, setSaving] = useState(false);
  const [formMessage, setFormMessage] = useState("");
  const [form, setForm] = useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    mobileNumber: "",
    dateOfBirth: "",
    gender: "",
    clientId: "",
    role: "3",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    setFormMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormMessage("");

    if (!form.email || !form.email.trim()) {
      setFormMessage("Email is required");
      return;
    }
    {form.emailPrefix && form.emailPrefix.length < 7 && (
  <small style={{ color: "red" }}>
    Email user id must be at least 7 characters
  </small>
)}

    setSaving(true);
    try {
      const payload = { email: form.email.trim().toLowerCase() };
      const first = form.firstName?.trim() || "";
      const last = form.lastName?.trim() || "";
      const combined = `${first} ${last}`.trim();
      if (combined) payload.fullName = combined;
      if (form.password) payload.password = form.password;
      if (form.mobileNumber && form.mobileNumber.trim()) payload.mobileNumber = form.mobileNumber.trim();
      if (form.dateOfBirth) payload.dateOfBirth = form.dateOfBirth;
      if (form.gender) payload.gender = form.gender;
      if (form.clientId) payload.clientId = Number(form.clientId);
      // Send numeric role for newer API; keep isAdmin for backwards compatibility
      payload.role = Number(form.role || 3);
      payload.isAdmin = Number(form.role || 3) !== 3;

      const result = await onCreate(payload);
      // parent handles adding user to list and toast; close modal now
      setSaving(false);
      onClose(result);
      // reset form for next open
      setForm({ email: "", firstName: "", lastName: "", password: "", mobileNumber: "", dateOfBirth: "", gender: "", clientId: "", role: "3" });
    } catch (err) {
      setFormMessage(err?.message || "Failed to create user");
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  if (!isOpen) return null;

return (
<div className="modal-overlay">
  <div className="contacts-form"> {/* ✅ reuse same class */}

    <h3 className="form-title">Add New User</h3>

    <form onSubmit={handleSubmit} className="form-body">

      {/* EMAIL */}
      <div className="input-group">
        <input
          type="text"
          placeholder=" "
          name="email"
          value={form.email}
          onChange={handleChange}
        />
        <label>Email</label>
      </div>

      {/* MOBILE */}
      <div className="input-group">
        <input
          type="text"
          placeholder=" "
          name="mobileNumber"
          value={form.mobileNumber}
          onChange={handleChange}
        />
        <label>Mobile Number</label>
      </div>

      {/* NAME ROW */}
      <div className="form-row">
        <div className="input-group">
          <input
            type="text"
            placeholder=" "
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
          />
          <label>First Name</label>
        </div>

        <div className="input-group">
          <input
            type="text"
            placeholder=" "
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
          />
          <label>Last Name</label>
        </div>
      </div>

      {/* PASSWORD */}
      <div className="input-group">
        <input
          type="password"
          placeholder=" "
          name="password"
          value={form.password}
          onChange={handleChange}
        />
        <label>Password</label>
      </div>

      {/* DOB + GENDER */}
      <div className="form-row">
        <div className="input-group">
          <input
            type="date"
            name="dateOfBirth"
            value={form.dateOfBirth}
            onChange={handleChange}
          />
          <label className="active">Date of Birth</label>
        </div>

        <div className="input-group">
          <select
            name="gender"
            value={form.gender}
            onChange={handleChange}
          >
            {genderOptions.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* COMPANY + ROLE */}
      <div className="form-row">
        <div className="input-group">
          <select
            name="clientId"
            value={form.clientId}
            onChange={handleChange}
          >
            <option value="">-- none --</option>
            {clients.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        <div className="input-group">
          <select
            name="role"
            value={form.role}
            onChange={(e) =>
              setForm(p => ({ ...p, role: e.target.value }))
            }
          >
            <option value="2">Admin</option>
            <option value="3">User</option>
          </select>
        </div>
      </div>

      {/* ERROR */}
      {formMessage && (
        <div className="form-error">{formMessage}</div>
      )}

      {/* BUTTONS */}
      <div className="form-buttons">
        <button type="submit" className="btn-primary">
          {saving ? "Creating…" : "Create User"}
        </button>

        <button
          type="button"
          className="btn-secondary"
          onClick={() => onClose(null)}
        >
          Cancel
        </button>
      </div>

    </form>
  </div>
</div>
);

}

export default UserModal;
